export default __webpack_public_path__ + "static/media/industry_screenshot.70eae52a.png";